export default ({points = null}) => {
  return points > 0
    ? `+${points}`
    : points;
}
